import { DipType } from "interfaces/dip/dip";
import styled from "styled-components";

export const BackgroundImage = styled.img`
	border-radius: 30px;
	width: 100%;
	height: 100%;
	position: absolute;
	object-fit: cover;
	top: 0;
	left: 0;
	z-index: -1;
`;

export const Video = styled.video.attrs<{
	dipType: DipType | undefined;
}>({
	preload: "metadata"
})<{ dipType: DipType | undefined }>`
	width: 100%;
	position: absolute;
	z-index: -1;
	object-fit: cover;
	bottom: 0;
	right: 0;
	height: ${(props) => (props.dipType === "informative" ? "100%" : "unset")};
	/* Properties to stabilize the video */
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
	transform: translateZ(0);
	-webkit-transform: translateZ(0);
	will-change: auto;
	@media (orientation: portrait) {
		min-height: 380px;
		height: 100%;
	}
`;

export const Image = styled.img<{ dipType: DipType | undefined }>`
	width: 100%;
	position: absolute;
	z-index: -1;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	bottom: 0;
	right: 0;
	height: ${(props) => (props.dipType === "informative" ? "100%" : "unset")};
	@media (orientation: portrait) {
		min-height: 380px;
		height: 100%;
	}
`;
